module.exports = __webpack_public_path__ + "static/teacher-94e2f09cbb4930586e195f2da54007ba.jpg";